module.exports = __webpack_public_path__ + "img/e4_img1.d5b2185.webp";